import { useTranslation } from 'react-i18next'

import { ResultSection } from 'aem-libs-react-components/src/components/calculators/components/result-section'
import { useMonthsSplitLabel } from 'aem-libs-react-ts/src/hooks/useMonthsSplitLabel'

import { testIds } from '../e2e/testIds'
import { useBurinkaLoanConsolidationQuery } from '../hooks/useBurinkaLoanConsolidationQuery'
import { loansConsolidationStore } from '../store'
import { CtaButtons } from './CtaButtons'

export const ResultBoard = () => {
  const { t } = useTranslation()
  const { response, isFetching } = useBurinkaLoanConsolidationQuery()

  const values = loansConsolidationStore.useStoreData()

  const installmentAmount = response?.installmentAmount ? Math.round(response.installmentAmount.value) : 0
  const durationSplit = useMonthsSplitLabel(response?.installmentCount as number, { separator: ' ' + t('AND') + ' ' })
  const monthlyPaymentsBonus = values.monthlyPayment - installmentAmount

  return (
    <ResultSection.Container loading={isFetching} testId={testIds.resultSectionContainer}>
      <ResultSection.SimpleRow label={t('RESULTS.RESULT_PAYMENT')} withBorder>
        <ResultSection.AnimatedValue
          ariaLabel={t('RESULTS.RESULT_PAYMENT')}
          skipAnimation={isFetching}
          value={installmentAmount}
          unitType={'czk'}
          testId={testIds.resultMonthly}
        />
      </ResultSection.SimpleRow>
      {monthlyPaymentsBonus > 0 && (
        <ResultSection.SimpleRow id='monthlySave' label={t('RESULTS.MONTHLY_SAVE')} withBorder>
          <ResultSection.AnimatedValue
            ariaLabel={t('RESULTS.MONTHLY_SAVE')}
            skipAnimation={isFetching}
            value={monthlyPaymentsBonus}
            unitType={'czk'}
            testId={testIds.resultMonthlyPaymentsSave}
          />
        </ResultSection.SimpleRow>
      )}
      <ResultSection.SimpleRow
        id='duration'
        label={t('RESULTS.RESULT_DURATION')}
        withBorder
        testId={testIds.resultDuration}
      >
        <div aria-labelledby='duration' aria-atomic={true} aria-live='polite' role='status'>
          <strong>{durationSplit}</strong>
        </div>
      </ResultSection.SimpleRow>
      <ResultSection.SimpleRow id='interestRate' label={t('RESULTS.INTEREST_RATE')} withBorder>
        <ResultSection.Value
          ariaLabel={t('RESULTS.INTEREST_RATE')}
          value={response?.interestRate}
          unitType={'percent'}
          testId={testIds.resultInterestRate}
        />
      </ResultSection.SimpleRow>
      <ResultSection.SimpleRow id='rpsn' label={t('RESULTS.RPSN')} withBorder>
        <ResultSection.Value
          ariaLabel={t('RESULTS.RPSN')}
          value={response?.rpsn}
          unitType={'percent'}
          testId={testIds.resultRpsn}
        />
      </ResultSection.SimpleRow>
      <CtaButtons testId={testIds.resultCta} />
    </ResultSection.Container>
  )
}
